import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import {
  scheduleDeadlinesSelector,
  scheduleEventsSelector,
  scheduleSelector,
  todaySelector,
} from '../actions/selectors'
import { scheduleActionsAreEqual } from '../utils'
import { ScheduleWrapper } from './ui/Schedule'
import ScheduleDay from './ScheduleDay'
import { isEqual, orderBy } from 'lodash'

const mapStateToProps = (state) => ({
  scheduleActions: state.loaded ? scheduleSelector(state) : {},
  scheduleEvents: scheduleEventsSelector(state),
  scheduleDeadlines: scheduleDeadlinesSelector(state),
  today: todaySelector(state),
})

const propsAreEqual = (prevProps, nextProps) => {
  if (prevProps.today !== nextProps.today) return false
  if (prevProps.darkMode !== nextProps.darkMode) return false

  const scheduleEqual = scheduleActionsAreEqual(
    prevProps.scheduleActions,
    nextProps.scheduleActions,
  )
  if (!scheduleEqual) return false

  if (!isEqual(prevProps.scheduleEvents, nextProps.scheduleEvents)) return false

  return true
}

const getScheduleDays = (scheduleActions) =>
  // Sort schedule days: date strings first (chronologically), then "later", then "someday" at the bottom
  orderBy(Object.entries(scheduleActions), [
    ([date]) => {
      // Put "someday" at the end (highest sort value)
      if (date === 'someday') return 2
      // Put "later" before "someday" but after dates
      if (date === 'later') return 1
      // Date strings (YYYYMMDD) sort naturally as numbers
      return 0
    },
    ([date]) => date, // Secondary sort: alphabetical/chronological for dates
  ])

const Schedule = React.memo(
  ({ scheduleActions, scheduleEvents, scheduleDeadlines, darkMode }) => (
    <ScheduleWrapper darkMode={darkMode}>
      {getScheduleDays(scheduleActions).map(([date, actions]) => (
        <ScheduleDay
          key={date}
          date={date}
          darkMode={darkMode}
          actions={actions}
          events={scheduleEvents[date]}
          deadlines={scheduleDeadlines[date]}
        />
      ))}
    </ScheduleWrapper>
  ),
  propsAreEqual,
)

Schedule.propTypes = {
  darkMode: PropTypes.bool.isRequired,
  scheduleActions: PropTypes.objectOf(
    // date: []
    PropTypes.arrayOf(
      // array of Actions
      PropTypes.shape({
        identifier: PropTypes.string.isRequired,
        title: PropTypes.string.isRequired,
        due: PropTypes.shape({
          day: PropTypes.number,
        }),
      }),
    ),
  ),
}

Schedule.displayName = 'Schedule'

export default connect(mapStateToProps)(Schedule)
